import React, { useEffect, useState } from "react";
import { supabase } from "../Utils/supabaseClient";
import { DashboardLayout } from "../Components";

export default function ChatTable() {
  const [messages, setMessages] = useState([]);
  const today = new Date().toISOString().split("T")[0];
  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const [senderSearch, setSenderSearch] = useState("");
  const [receiverSearch, setReceiverSearch] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const fetchMessages = async (filter = false, currentPage = page) => {
    let query = supabase
      .from("messages")
      .select("*", { count: "exact" })
      .order("created_at", { ascending: false });

    if (fromDate && toDate) {
      if (fromDate) query = query.gte("created_at", new Date(fromDate + "T00:00:00Z").toISOString());
      if (toDate) query = query.lte("created_at", new Date(toDate + "T23:59:59Z").toISOString());
    }
    if (senderSearch.trim()) {
      query = query.ilike("sender_id", `%${senderSearch}%`);
    }
    if (receiverSearch.trim()) {
      query = query.ilike("receiver_id", `%${receiverSearch}%`);
    }

    const from = (currentPage - 1) * pageSize;
    const to = from + pageSize - 1;
    query = query.range(from, to);

    const { data, error, count } = await query;
    if (error) {
      console.error("Error fetching messages:", error);
    } else {
      setMessages(data);
      if (count !== null) setTotalCount(count);
    }
  };

  useEffect(() => {
    fetchMessages();
  }, [page]);

  const totalPages = Math.ceil(totalCount / pageSize);
  return (
    
      <div style={{ padding: "24px", background: "#f9fafb", minHeight: "100vh" }}>
        {/* Filter Section */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "flex-end",
            gap: "16px",
            marginBottom: "24px",
            background: "white",
            padding: "16px",
            borderRadius: "10px",
            boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
          }}
        >
          {/* From Date */}
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label style={{ fontSize: "13px", fontWeight: 600, color: "#4b5563", marginBottom: "4px" }}>
              From
            </label>
            <input
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              style={{
                border: "1px solid #d1d5db",
                borderRadius: "6px",
                padding: "6px 10px",
                fontSize: "14px",
                width: "170px",
              }}
            />
          </div>

          {/* To Date */}
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label style={{ fontSize: "13px", fontWeight: 600, color: "#4b5563", marginBottom: "4px" }}>
              To
            </label>
            <input
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              style={{
                border: "1px solid #d1d5db",
                borderRadius: "6px",
                padding: "6px 10px",
                fontSize: "14px",
                width: "170px",
              }}
            />
          </div>

          {/* Sender Search */}
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label style={{ fontSize: "13px", fontWeight: 600, color: "#4b5563", marginBottom: "4px" }}>
              Search by Sender
            </label>
            <input
              type="text"
              value={senderSearch}
              onChange={(e) => setSenderSearch(e.target.value)}
              placeholder="Enter sender ID"
              style={{
                border: "1px solid #d1d5db",
                borderRadius: "6px",
                padding: "6px 10px",
                fontSize: "14px",
                width: "170px",
              }}
            />
          </div>

          {/* Receiver Search */}
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label style={{ fontSize: "13px", fontWeight: 600, color: "#4b5563", marginBottom: "4px" }}>
              Search by Receiver
            </label>
            <input
              type="text"
              value={receiverSearch}
              onChange={(e) => setReceiverSearch(e.target.value)}
              placeholder="Enter receiver ID"
              style={{
                border: "1px solid #d1d5db",
                borderRadius: "6px",
                padding: "6px 10px",
                fontSize: "14px",
                width: "170px",
              }}
            />
          </div>

          {/* Buttons */}
          <button
            onClick={() => {
              setPage(1);
              fetchMessages(true, 1);
            }}
            style={{
              backgroundColor: "#2563eb",
              color: "white",
              padding: "8px 16px",
              borderRadius: "8px",
              boxShadow: "0px 2px 6px rgba(0,0,0,0.2)",
              transition: "background-color 0.3s ease",
              border: "none",
              cursor: "pointer",
              height: "38px",
            }}
            onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#1d4ed8")}
            onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#2563eb")}
          >
            Apply Filter
          </button>

          <button
            onClick={() => {
              setFromDate("");
              setToDate("");
              setSenderSearch("");
              setReceiverSearch("");
              setPage(1);
              fetchMessages(false, 1);
            }}
            style={{
              backgroundColor: "#6B7280",
              color: "#ffffff",
              padding: "8px 16px",
              borderRadius: "8px",
              boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
              cursor: "pointer",
              transition: "background-color 0.3s ease",
              border: "none",
              height: "38px",
            }}
            onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#4B5563")}
            onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#6B7280")}
          >
            Reset
          </button>
        </div>

        {/* Table Section */}
        <div
          style={{
            overflowX: "auto",
            boxShadow: "0px 2px 8px rgba(0,0,0,0.1)",
            borderRadius: "10px",
            border: "1px solid #e5e7eb",
            background: "white",
          }}
        >
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "14px" }}>
            <thead style={{ background: "#f3f4f6", color: "#374151" }}>
              <tr>
                {["S.No", "Sender", "Receiver", "Content", "Type", "File", "Created At", "Read At"].map((header) => (
                  <th key={header} style={{ padding: "12px", border: "1px solid #e5e7eb", textAlign: "left" }}>
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {messages.length > 0 ? (
                messages.map((msg, index) => {
                  const serialNo = (page - 1) * pageSize + index + 1;
                  return (
                    <tr
                      key={msg.id}
                      style={{ transition: "background 0.2s" }}
                      onMouseOver={(e) => (e.currentTarget.style.background = "#f9fafb")}
                      onMouseOut={(e) => (e.currentTarget.style.background = "white")}
                    >
                      <td style={{ padding: "12px", border: "1px solid #e5e7eb", color: "#4b5563" }}>{serialNo}</td>
                      <td style={{ padding: "12px", border: "1px solid #e5e7eb" }}>{msg.sender_id}</td>
                      <td style={{ padding: "12px", border: "1px solid #e5e7eb" }}>{msg.receiver_id}</td>
                      <td style={{ padding: "12px", border: "1px solid #e5e7eb" }}>{msg.content}</td>
                      <td style={{ padding: "12px", border: "1px solid #e5e7eb" }}>{msg.type}</td>
                      <td style={{ padding: "12px", border: "1px solid #e5e7eb" }}>
                        {msg.file_url ? (
                          <a href={msg.file_url} target="_blank" rel="noreferrer" style={{ color: "#2563eb", textDecoration: "underline" }}>
                            {msg.file_name || "Download"}
                          </a>
                        ) : (
                          "-"
                        )}
                      </td>
                      <td style={{ padding: "12px", border: "1px solid #e5e7eb" }}>
                        {msg.created_at
                          ? msg.created_at.replace('T', ' ').replace('+00:00', '').split('.')[0]
                          : '-'}
                      </td>

                      <td style={{ padding: "12px", border: "1px solid #e5e7eb" }}>
                        {msg.read_at
                          ? msg.read_at.replace('T', ' ').replace('+00:00', '').split('.')[0]
                          : '-'}
                      </td>

                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="8" style={{ padding: "16px", textAlign: "center", color: "#6b7280", border: "1px solid #e5e7eb" }}>
                    No messages found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "16px" }}>
          <p style={{ fontSize: "14px", color: "#4b5563" }}>
            Page {page} of {totalPages || 1}
          </p>
          <div style={{ display: "flex", gap: "8px" }}>
            <button
              disabled={page === 1}
              onClick={() => setPage((p) => Math.max(1, p - 1))}
              style={{
                padding: "8px 16px",
                borderRadius: "6px",
                border: "1px solid #d1d5db",
                cursor: page === 1 ? "not-allowed" : "pointer",
                background: page === 1 ? "#e5e7eb" : "white",
                color: page === 1 ? "#9ca3af" : "black",
              }}
            >
              Previous
            </button>
            <button
              disabled={page === totalPages || totalPages === 0}
              onClick={() => setPage((p) => p + 1)}
              style={{
                padding: "8px 16px",
                borderRadius: "6px",
                border: "1px solid #d1d5db",
                cursor: page === totalPages || totalPages === 0 ? "not-allowed" : "pointer",
                background: page === totalPages || totalPages === 0 ? "#e5e7eb" : "white",
                color: page === totalPages || totalPages === 0 ? "#9ca3af" : "black",
              }}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    
  );
}
